var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m27.227 20.917-6.21-1.664c.204-2.22 0-4.745-1.205-7.11-.18-6.195 1.867-11.962 6.835-10.631 5.468 1.466 4.865 13.9.58 19.404zm-.409 2.619c-.343 11.973-12.512 6.497-6.318-1.693zm-21.76-2.618 6.21-1.664c-.204-2.22 0-4.745 1.205-7.11.18-6.195-1.867-11.962-6.835-10.631C.17 2.978.773 15.412 5.058 20.917zm.41 2.619c.343 11.974 12.512 6.497 6.318-1.693z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.53c6ea266ea72fd3fa79de15140e07ff.svg";
export { ForwardRef as ReactComponent };